export const StarterUtils = {
    /**
     * Отправляет сообщение, что приложение не найдено
     */
    writeAppNotFoundMessage(): void {
        document.write(
            '<div style="margin: 20px"><h1>Ого!</h1><p>Что-то пошло не так. ' +
                'Мы не смогли найти приложение, которое вы искали.</p></div>',
        );
    },
    whiteAppNotFoundInEngine(app: string): void {
        document.write(
            '<div style="margin: 20px"><h1>Ого!</h1><p>Что-то пошло не так. ' +
                'Мы не смогли найти приложение <b>' +
                app +
                '</b></p></div>',
        );
    },
};
export const StarterUtils = {
    /**
     * Отправляет сообщение, что приложение не найдено
     */
    writeAppNotFoundMessage(): void {
        document.write(
            '<div style="margin: 20px"><h1>Ого!</h1><p>Что-то пошло не так. ' +
                'Мы не смогли найти приложение, которое вы искали.</p></div>',
        );
    },
    whiteAppNotFoundInEngine(app: string): void {
        document.write(
            '<div style="margin: 20px"><h1>Ого!</h1><p>Что-то пошло не так. ' +
                'Мы не смогли найти приложение <b>' +
                app +
                '</b></p></div>',
        );
    },
};
